/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/dashboard",
    slug: "dashboard",
    icon: "ZapIcon",
    i18n: "Dashboard",
  },
  {
    url: null,
    icon: "ActivityIcon",
    i18n: "Overviews",
    permission: 1302,
    submenu: [
      {
        url: '/company/openTasks',
        slug: 'openTasks',
        i18n: 'OpenTasks',
        permission: 1301
      },
      {
        url: '/company/clientTimeOverview',
        slug: 'clientTimeOverview',
        i18n: 'ClientTimeOverview',
        permission: 1303
      },
      {
        url: '/company/timeAnalytics',
        slug: 'timeAnalytics',
        i18n: 'TimeAnalytics',
        permission: 1304
      },
    ]
  },
  {
    url: null,
    icon: "ListIcon",
    i18n: "Tasks",
    submenu: [
      {
        url: '/tasks/own',
        slug: 'ownTasks',
        i18n: 'OwnTasks'
      },
      {
        url: '/tasks/paused',
        slug: 'pausedTasks',
        i18n: 'PausedTasks'
      },
      {
        url: '/tasks/all',
        slug: 'allTasks',
        i18n: 'AllTasks'
      },
      {
        url: '/tasks/unassigned',
        slug: 'unassignedTasks',
        i18n: 'UnassignedTasks'
      },
      {
        url: '/tasks/waitingForConfirmation',
        slug: 'tasksWaitingForConfirmation',
        i18n: 'SentForConfirmation'
      },
      {
        url: '/tasks/closed',
        slug: 'closedTasks',
        i18n: 'ClosedTasks'
      }
    ]
  },
  {
    url: null,
    icon: "DollarSignIcon",
    i18n: "Commercial",
    permission: 208,
    submenu: [
      {
        url: "/projectOffers",
        slug: "projectOffers",
        i18n: "ProjectOffers",
        permission: 208
      },
      {
        url: null,
        icon: "MessageCircleIcon",
        i18n: "Meetings",
        permission: 2001,
        submenu: [
          {
            url: "/myMeetings",
            slug: "myMeetings",
            i18n: "MyMeetings",
            permission: 2001
          },
          {
            url: "/plannedMeetings",
            slug: "plannedMeetings",
            i18n: "PlannedMeetings",
            permission: 2001
          },
          {
            url: "/finishedMeetings",
            slug: "finishedMeetings",
            i18n: "FinishedMeetings",
            permission: 2001
          },
        ]
      },
      {
        url: null,
        icon: "BookIcon",
        i18n: "Offers",
        permission: 1901,
        submenu: [
          {
            url: "/myOffers",
            slug: "myOffers",
            i18n: "MyOffers",
            permission: 1901
          },
          {
            url: "/allOffers",
            slug: "allOffers",
            i18n: "AllOffers",
            permission: 1901
          },
          {
            url: "/finishedOffers",
            slug: "finishedOffers",
            i18n: "FinishedOffers",
            permission: 1901
          },
          {
            url: "/archivedOffers",
            slug: "archivedOffers",
            i18n: "ArchivedOffers",
            permission: 1901
          },
          {
            url: "/offersInMaking",
            slug: "offersInMaking",
            tagColor: "warning",
            i18n: "OffersInMaking",
            permission: 1903
          },
          {
            url: "/approvedOffers",
            slug: "approvedOffers",
            tagColor: "success",
            i18n: "ApprovedOffers",
            permission: 1903
          },
        ]
      },
    ]
  },
  {
    url: null,
    icon: "AwardIcon",
    i18n: "Projects",
    submenu: [
      {
        url: "/projects/own",
        slug: "projectsOwn",
        i18n: "OwnProjects",
      },
      {
        url: "/projects/open",
        slug: "projectsOpen",
        i18n: "OpenProjects",
      },
      {
        url: "/projects/finished",
        slug: "projectsFinished",
        i18n: "FinishedProjects",
      },
      {
        url: "/projects/all",
        slug: "projectsAll",
        i18n: "AllProjects",
      },
      {
        url: "/projectTemplates",
        slug: "projectTemplates",
        i18n: "ProjectTemplates",
        permission: 204
      }
    ]
  },
  {
    url: null,
    icon: "CalendarIcon",
    i18n: "Calendar",
    permission: 1401,
    submenu: [
      {
        url: "/absenceCalendar",
        slug: "absenceCalendar",
        i18n: "Absences",
        permission: 1401
      },
      {
        url: "/onCallCalendar",
        slug: "onCallCalendar",
        i18n: "OnCall",
      },
    ]
  },
  {
    url: "/business_trips",
    slug: "businessTrips",
    icon: "MapPinIcon",
    i18n: "BusinessTrips",
  },
  {
    url: "/wiki",
    slug: "wiki",
    icon: "DatabaseIcon",
    i18n: "Documentation",
    permission: 2101,
    required_company: 1,
  },
  {
    url: "/wiki_komerciala",
    slug: "wikiKomerciala",
    icon: "BookOpenIcon",
    i18n: "CommercialWiki",
    permission: 2102,
    required_company: 1,
  },
  {
    url: "/wiki_board",
    slug: "wikiBoard",
    icon: "ClipboardIcon",
    i18n: "BoardWiki",
    permission: 2103,
    required_company: 1,
  },
  {
    url: "/wiki_iso",
    slug: "wikiIso",
    icon: "AlertTriangleIcon",
    i18n: "ISOWiki",
    permission: 2104,
    required_company: 1,
  },
  {
    url: "/wiki_meetings",
    slug: "wikiMeetings",
    icon: "ClipboardIcon",
    i18n: "MeetingsWiki",
    permission: 2105,
    required_company: 1,
  },
  {
    url: "/clients",
    slug: "clients",
    icon: "HomeIcon",
    i18n: "Clients",
    permission: 301
  },
  {
    url: null,
    icon: "BookIcon",
    i18n: "Invoicing",
    permission: 1101,
    submenu: [
      {
        url: '/invoicing/tasks',
        slug: 'invoicingTasks',
        i18n: 'TasksWaiting',
        permission: 1101
      },
      {
        url: '/invoicing/waiting',
        slug: 'invoicingWaiting',
        i18n: 'InvoicesWaiting',
        permission: 1101
      },
      {
        url: '/invoicing/done',
        slug: 'invoicingDone',
        i18n: 'InvoicesFinished',
        permission: 1101
      },
      {
        url: null,
        i18n: "Projects",
        icon: "AwardIcon",
        submenu: [
          {
            url: '/invoicing/projects/waiting',
            slug: 'invoicingProjectsWaiting',
            i18n: 'Waiting',
            permission: 1101
          },
          {
            url: '/invoicing/projects/done',
            slug: 'invoicingProjectsDone',
            i18n: 'InvoicedProjects',
            permission: 1101
          }
        ]
      },
    ]
  },
  {
    url: "/users",
    slug: "users",
    icon: "UserIcon",
    i18n: "Users",
    tagColor: "warning",
    permission: 401
  },
  {
    url: "/roles",
    slug: "roles",
    icon: "UsersIcon",
    i18n: "Roles",
    permission: 701
  },
  {
    url: "/registration_terminals",
    slug: "registration_terminals",
    icon: "MonitorIcon",
    i18n: "RegistrationTerminals",
    permission: 2201
  },
  {
    url: "/userTypes",
    slug: "userTypes",
    icon: "UsersIcon",
    i18n: "UserTypes",
    permission: 601
  },
  {
    url: "/tags",
    slug: "tags",
    icon: "TagIcon",
    i18n: "Tags",
    permission: 1501
  },
  {
    url: null,
    icon: "MapIcon",
    i18n: "Transport",
    submenu: [
      {
        url: '/travel_order',
        slug: 'travelOrders',
        i18n: 'TravelOrders',
        permission: 1201
      },
      {
        url: '/vehicles',
        slug: 'vehicles',
        i18n: 'Vehicles',
      },
      {
        url: '/transportTypes',
        slug: 'transportTypes',
        i18n: 'TransportTypes',
        permission: 901
      },
      {
        url: '/at_vehicles',
        slug: 'atVehicles',
        i18n: 'atVehicles',
        permission: 1601,
        required_company: 1,
      },
    ]
  },
  {
    url: "/settings",
    slug: "settings",
    icon: "SettingsIcon",
    i18n: "Settings",
    permission: 1001
  },
  {
    url: "/workTypes",
    slug: "workTypes",
    icon: "BriefcaseIcon",
    i18n: "WorkTypes",
    permission: 501
  },
]
